import ROUTES from '../../../../../constants/routes';
import { getLegacyOfferGroup } from '../../../../../utils/productIdentityUtils';
import { selectWeightedVariant } from '../../../../../components/ABTest/calculateActiveExperimentVariant';
import { getCompoundedGlp1 } from './compoundedGlp1';
import { CHECKOUT_LAYOUT_PROGRAM_SLUGS, CHECKOUT_LAYOUT_STEP_NUMBERS, CHECKOUT_LAYOUT_VARIANTS, CHECKOUT_LAYOUT_WEIGHTS } from '../constants';
import type { CheckoutLayoutArm } from '../constants';

// the emitter's order, by variant name, so a lead lands on the arm useCheckoutLayoutExperiment renders for it
const SORTED_VARIANTS = [...CHECKOUT_LAYOUT_VARIANTS].sort();
const SORTED_WEIGHTS = SORTED_VARIANTS.map((variant) => CHECKOUT_LAYOUT_WEIGHTS[CHECKOUT_LAYOUT_VARIANTS.indexOf(variant)]);

// the layouts are designed and priced for compounded GLP-1s only
export const isCheckoutLayoutEntry = (programSlug: string | null | undefined, productSku: string | null | undefined): boolean => (
	CHECKOUT_LAYOUT_PROGRAM_SLUGS.includes((programSlug ?? '').toLowerCase()) && getCompoundedGlp1(productSku ?? null) !== null
);

export const getCheckoutLayoutPath = (programSlug: string, productSku: string, leadId: string, search: string): string => {
	const params = new URLSearchParams(search);
	params.set('lid', leadId);

	return `${ROUTES.PROGRAM_FUNNEL_CHECKOUT}/${programSlug.toLowerCase()}/${getLegacyOfferGroup(productSku)?.offerToken ?? productSku}?${params.toString()}`;
};

export const getAllocatedCheckoutLayout = (leadId: string): CheckoutLayoutArm => (
	selectWeightedVariant(SORTED_VARIANTS, SORTED_WEIGHTS, leadId) as CheckoutLayoutArm
);

export const getCheckoutLayoutStepNumber = (leadId: string): number => CHECKOUT_LAYOUT_STEP_NUMBERS[getAllocatedCheckoutLayout(leadId)];

export const isCheckoutLayoutStep = (stepNumber: unknown): boolean => (
	Object.values(CHECKOUT_LAYOUT_STEP_NUMBERS).some((layoutStepNumber) => layoutStepNumber === stepNumber)
);
